import { useEffect, useState } from "react";

import useDataContext from "../../providers/DataProvider/useDataContext";
import { subscribeToScroll } from "../../assets/scripts/ScrollManager";
import { WhatsappIcon } from "../Icons/Icons";
import "./Whatsapp.css"


interface Props {
    isHomePage: boolean
}

const Whatsapp: React.FC<Props> = ({ isHomePage }) => {
    const { data } = useDataContext();
    const [isFixed, setIsFixed] = useState(!isHomePage)

    useEffect(() => {
        if (isHomePage) {
            const unsuscribe = subscribeToScroll(setIsFixed);
            return () => {
                unsuscribe();
            } 
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div className={`fixed bottom-[88px] lg:bottom-24 right-1 lg:right-3 z-40 size-14 lg:size-16
                       bg-forth-solid rounded-full border-4 border-first-solid
                         transition duration-500 ease-out opacity-0
                       hover:bg-third-solid
                       ${ isFixed ? "isFixed" : ""}`}>
            <a aria-label="whatsapp-link"
               href={ data.components.whatsappApiLink }
               target="_blank"
               rel="noreferrer"
               className="size-full flex justify-center items-center">
                <WhatsappIcon className="size-6 lg:size-8 text-first-solid"/>
            </a>
        </div>
    );
}

export default Whatsapp;
